export default __webpack_public_path__ + "assets/thermometer-fahrenheit.c83507be.svg";